import { useEffect } from "react";

export default function MilletModal({ millet, onClose }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        {millet.img && (
          <img
            src={millet.img}
            alt={millet.name}
            style={{ width: "100%", height: "180px", objectFit: "cover", borderRadius: "8px", marginBottom: "1.2rem" }}
            loading="lazy"
          />
        )}
        <h2 className="modal-title">{millet.name}</h2>
        <div className="modal-hindi">{millet.hindi}</div>
        {millet.sci && <div className="modal-sci">{millet.sci}</div>}
        <p className="modal-body">{millet.detail}</p>
      </div>
    </div>
  );
}